/**
 * <localization-selects> wraps a Shopify localization form and submits it as soon as a country or
 * language is chosen, so no extra button is needed. Without JavaScript the form's own button is shown.
 */
class LocalizationSelects extends HTMLElement {
  connectedCallback() {
    this.addEventListener('change', this.#onChange);
  }

  disconnectedCallback() {
    this.removeEventListener('change', this.#onChange);
  }

  #onChange = (event) => {
    if (!(event.target instanceof HTMLSelectElement)) return;
    this.querySelector('form')?.requestSubmit();
  };
}

if (!customElements.get('localization-selects')) {
  customElements.define('localization-selects', LocalizationSelects);
}
